import FormItem from "components/Common/FormItem"
import React from "react"
import {
  Button,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap"
import useAddressForm from "./useAddressForm"

export default function AddressForm({
  toggle,
  auth,
  notify,
  modal,
  addressId,
}) {
  const { values, setValue, handleSubmit } = useAddressForm({
    auth,
    notify,
    toggle,
    addressId,
  })
  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalHeader toggle={toggle}>
        {!addressId ? "Add" : "Update"} Address
      </ModalHeader>
      <ModalBody>
        <Col md="12">
          <FormItem
            id="address-name"
            placeholder="Max Muller"
            label="NAME"
            value={values?.name}
            onChange={(e) => setValue("name", e.target.value)}
          />
        </Col>
        <Col md="12">
          <FormItem
            id="address-line-1"
            placeholder="1625 Imperial Heights"
            label="ADDRESS LINE 1"
            value={values?.addressLine1}
            onChange={(e) => setValue("addressLine1", e.target.value)}
          />
        </Col>
        <Col md="12">
          <FormItem
            id="address-line-2"
            placeholder="Next to Starbucks"
            label="ADDRESS LINE 2"
            value={values?.addressLine2}
            onChange={(e) => setValue("addressLine2", e.target.value)}
          />
        </Col>
        <Col md="12">
          <FormItem
            id="city"
            placeholder="Los Angeles"
            label="CITY"
            value={values?.city}
            onChange={(e) => setValue("city", e.target.value)}
          />
        </Col>
        <Col md="12">
          <FormItem
            id="state"
            placeholder="California"
            label="STATE"
            value={values?.state}
            onChange={(e) => setValue("state", e.target.value)}
          />
        </Col>
        <Col md="12">
          <FormItem
            id="zipCode"
            placeholder="90103"
            label="ZIP CODE"
            value={values?.zipCode}
            onChange={(e) => setValue("zipCode", e.target.value)}
          />
        </Col>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit}>
          {!addressId ? "Add" : "Update"} Address
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  )
}
